import type { SessionStorage } from '../core/auth/session.js';

/**
 * localStorage, wrapped so it can never throw.
 *
 * It throws outright in a few real contexts - Safari private mode historically, a browser set
 * to block site data, an embedded webview - and a sign-in screen that crashes because storage
 * is unavailable is a worse failure than one that simply asks the person to sign in again.
 */
export const browserSessionStorage: SessionStorage = {
  async get(key) { try { return localStorage.getItem(key); } catch { return null; } },
  async set(key, value) { try { localStorage.setItem(key, value); } catch { /* not fatal */ } },
  async remove(key) { try { localStorage.removeItem(key); } catch { /* not fatal */ } },
};
